module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"errorCode":"Код ошибки"}}')
  delete Component.options._Ctor
}
